module.exports = __webpack_public_path__ + "img/Blog3.760ca14a.png";